import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import PaymentMethodTypeEnum from "../../../../enums/payment_method_type_enum.js";

const contentStyles = makeStyles(theme => ({
  root: {
  },
}));

const PaymentMethodCell = (props) => {
  const classes = contentStyles();
  const { paymentMethod } = props;

  if(!paymentMethod) {
    return <React.Fragment>
      { "-" }
    </React.Fragment>
  }
  const { number } = paymentMethod;

  return (
    <div className = { classes.root } >
      {number}
    </div>
  )
}

export default PaymentMethodCell;
